import {ServiceBase} from '../ServiceBase';
import {ISpinnerService} from './spinner.service.interface';
import {action, observable} from 'mobx';
import {Check} from '@sparkware/app-utils';

export class SpinnerService extends ServiceBase implements ISpinnerService {

  get isSpinning(): boolean {
    return !Check.isNullOrUndefined(this._startTime);
  }

  @observable.ref
  private _startTime: number = null;

  @action.bound
  private _setSpinningStartTime(value: number): void {
    this._startTime = value;
  }


  startSpinner(): void {
    this._setSpinningStartTime(this.services.time.performanceNow());
  }

  @action.bound
  stopSpinner() {
    if(this.isSpinning) {
      this._setSpinningStartTime(null);
    }
  }

  /*
  private _hideSpinner() {
    this._setSpinningStartTime(null);
    this.services.webVitals?.siteFinishedLoading && (this.services.location.hasNavigationHistory===false) && this.services.webVitals.siteFinishedLoading();
  }
   */

  /*
  private _sendAnalytics(sourceUri: Uri, targetUri: Uri): void {

    let spinnerTime = this.services.splash.computeSplashTimeInSeconds(this._startTime);
    let action = 'splash-time-splash_inner';

    let sourceRoute = (sourceUri && sourceUri.pathName.toString()) || '';
    let targetRoute = (targetUri && targetUri.pathName.toString()) || '';

    let label = sourceRoute + ' > ' + targetRoute;
    this.services.logger.info('Spinner time:' + spinnerTime);
    this.services.analytics.sendTechnicalEvent(action, label, spinnerTime);

  }
   */
}
